import { GrappleModule } from "../../../interfaces/api/GrappleModule";
import { LowerBracket } from "../../../interfaces/api/LowerBracket";
import { Rototilt } from "../../../interfaces/api/Rototilt";
import { filterHelper } from "../../../shared/helpers/filterHelper";
import { filtering } from "../../../shared/helpers/productFilterHelper";
import { useMachineTonnage } from "../../../store/hooks/useMachineTonnage";
import { useMarket } from "../../../store/hooks/useMarket";
import { ProductData } from "../../../store/interfaces/productData";

interface FilterGrappleModulesProps {
  grappleModulesData: ProductData;
  lowerBracket: LowerBracket;
  tiltrotator: Rototilt;
}

interface FilterGrappleModulesOutput {
  filteredGrappleModules: GrappleModule[];
}

export const useFilterGrappleModules = ({
  grappleModulesData,
  lowerBracket,
  tiltrotator,
}: FilterGrappleModulesProps): FilterGrappleModulesOutput => {
  const market = useMarket();
  const machineTonnage = useMachineTonnage();

  if (!grappleModulesData) {
    return {
      filteredGrappleModules: [],
    };
  }

  const grappleModules = grappleModulesData.data as GrappleModule[];

  const filteredLowerBrackets = grappleModules
    .filter((grappleModule) => filtering.market(grappleModule, market))
    .filter((grappleModule) =>
      filterHelper.grappleModules({
        grappleModule,
        lowerBracket,
        machineTonnage,
        market,
        tiltrotator,
      })
    );

  return {
    filteredGrappleModules: filteredLowerBrackets || grappleModules,
  };
};
